// extracted by mini-css-extract-plugin
export default {"file":"styles_file__h5LSl","file__name":"styles_file__name__5pjgj","file__info":"styles_file__info__-lq45"};